import React, { useEffect, useState } from "react";
import logo from "./assets/images/logo.webp";
import userImg from "./assets/images/user.png";
// import logo from "./assets/images/lightlogo.webp";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RiUser6Line } from "react-icons/ri";
import { auth } from "../firebase";
import { MdOutlineLogout } from "react-icons/md";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { toast } from "react-toastify";
import { RiMenu4Fill } from "react-icons/ri";
import { RiHome3Line } from "react-icons/ri";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { FiPhoneCall } from "react-icons/fi";
import { IoCarSportOutline } from "react-icons/io5";

function Navbar() {
  const navigate = useNavigate();
  const [city, setCity] = useState("Detecting...");
  const [loading, setLoading] = useState(true);

  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [showLogin, setShowLogin] = useState(false);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const routerLocation = useLocation();
  const isActive = (path) => routerLocation.pathname === path;

  // 🔐 Auth + Fetch User Data
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        try {
          const docRef = doc(db, "Users", currentUser.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            setUserData(docSnap.data());
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        }
      } else {
        setUserData(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // 🌍 Location Detection
  useEffect(() => {
    if (!navigator.geolocation) {
      setCity("Location not supported");
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
          );
          const data = await res.json();

          const detectedCity =
            data.address.city ||
            data.address.town ||
            data.address.village ||
            "Location";

          setCity(detectedCity);
        } catch {
          setCity("Found");
        }

        setLoading(false);
      },
      () => {
        setCity("Permission!");
        setLoading(false);
      },
    );
  }, []);

  // 🔓 Logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success("Logged out successfully");
      window.location.reload();
    } catch {
      toast.error("Logout failed");
    }
  };

  return (
    <>
      <nav className="uber-navbar fixed-top">
        <div className="container">
          {/* Left - Logo */}
          <div className="nav-left">
            <Link className="uber-brand" to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>

          {/* Center - Location */}
          {/* <div className="nav-location desktopview">
            <span id="locationText">{loading ? "Fetching..." : city}</span>
          </div> */}

          {/* Right - Actions */}
          <div className="nav-right">
            <div className="nav-location">
              <span id="locationText">{loading ? "Fetching..." : city}</span>
            </div>

            {!user ? (
              <>
                <div className="nav-btn" onClick={() => navigate("/login")}>
                  <RiUser6Line />
                </div>
              </>
            ) : (
              <div className="nav-btn">
                <RiUser6Line />
              </div>
            )}

            <div className="nav-btn" onClick={() => setSidebarOpen(true)}>
              <RiMenu4Fill />
            </div>
          </div>
        </div>
      </nav>

      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between gap-2">
            <img src={userImg} alt="user" className="user-avatar mb-0" />
            <div className="profile-dropdownn">
              <div className="user-name mb-0">
                {(userData?.name || "User")
                  .trim()
                  .split(/\s+/)
                  .slice(0, 2)
                  .join(" ")}
              </div>
              <div className="user-id">
                Cust ID: #CS{(userData?.uid || "").slice(-5).toUpperCase()}
              </div>
            </div>
          </div>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => setSidebarOpen(false)}
          >
            ✕
          </span>
        </div>
        <hr />
        <ul className="sidebar-links list-unstyled p-0">
          <li>
            <Link to="/" onClick={() => setSidebarOpen(false)}>
              <RiHome3Line className="icon me-1" /> Home
            </Link>
          </li>
          {user && (
            <li>
              <Link to="/my-bookings" onClick={() => setSidebarOpen(false)}>
                <RiHome3Line className="icon me-1" /> My Bookings
              </Link>
            </li>
          )}
          <li>
            <Link to="/about-us-dibrugo" onClick={() => setSidebarOpen(false)}>
              <HiOutlineBuildingOffice className="icon me-1" /> About Us
            </Link>
          </li>

          <li>
            <Link to="/contact-us-dibrugo" onClick={() => setSidebarOpen(false)}>
              <FiPhoneCall className="icon me-1" /> Contact Us
            </Link>
          </li>

          <li>
            <Link to="/our-cars" onClick={() => setSidebarOpen(false)}>
              <IoCarSportOutline className="icon me-1" /> Our Vehicles
            </Link>
          </li>
          {user && (
            <li
              className="text-danger"
              style={{ cursor: "pointer" }}
              onClick={handleLogout}
            >
              <MdOutlineLogout className="icon me-1" /> Logout
            </li>
          )}
        </ul>
      </div>

      {/* Optional overlay to close sidebar on clicking outside */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Navbar;
